import { cn } from '@/lib/cn';
import { getRelationFieldNames } from '@/requests/instanceMapper';
import {
  InspectionErrandSettingConfig,
  type InspectionErrandSetting,
} from '@pigello/pigello-matrix';
import type { RelationFieldProps } from './types';
import { Badge } from '@/components/ui/badge';
import Dot from './dot';
import inspectionErrandSettingFilters from '@/app/settings/modules/errands/inspection/types/filters';

function getCategoryCount(
  categories: string[] | null | undefined,
  title: string
) {
  if (categories == null) {
    return `Alla ${title}`;
  }
  return `${categories.length} ${title}`;
}

export const InspectionErrandSettingItem: RelationFieldProps<InspectionErrandSetting> =
  {
    nested: getRelationFieldNames(InspectionErrandSettingConfig),
    filters: inspectionErrandSettingFilters,
    renderItem: (item, isRelationField) => ({
      title: item.name,
      badge: (
        <Badge variant={item.isActive ? 'green' : 'destructive'}>
          {item.isActive ? 'Aktiv' : 'Inaktive'}
        </Badge>
      ),
      descriptionItems: (
        <div className='flex flex-col gap-2'>
          <div
            className={cn(
              'flex w-full items-center',
              isRelationField && 'justify-between'
            )}
          >
            {getCategoryCount(
              item.apartmentCategories,
              'lägenhetskategori(er)'
            )}
            <Dot />
            {getCategoryCount(
              item.apartmentCategories,
              'brf-lägenhetskategori(er)'
            )}
            <Dot />
            {getCategoryCount(
              item.industrialPremisesCategories,
              'lokalkategori(er)'
            )}
          </div>
          <div
            className={cn(
              'flex w-full items-center',
              isRelationField && 'justify-between'
            )}
          >
            {getCategoryCount(
              item.outdoorSectionCategories,
              'utomhussektioner(er)'
            )}
            <Dot />
            {getCategoryCount(
              item.parkingSpotCategories,
              'fordonsplatskategori(er)'
            )}
          </div>
        </div>
      ),
    }),
  };
